<template>
    <span class="badge bg-info">
        <span v-for="_ in qtd" class="fas fa-bolt"></span>
    </span>
</template>
<script setup lang="ts">
import { EChargingSpeedType } from '@/enums';
import { computed } from 'vue';


const props = defineProps<{
    speedType: EChargingSpeedType | undefined
}>()

const qtd = computed(() => {
    if (props.speedType == EChargingSpeedType.fast) return 2
    if (props.speedType == EChargingSpeedType.ultra) return 3
    return 1
})


</script>